import { Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useState } from 'react'
import { BsFileEarmarkArrowDown } from 'react-icons/bs'
import { toast } from 'react-toastify'
import pubsub from '../../../../../modules/pubsub'
import spreadsheet from '../../../../../utils/spreadsheet'
import Modal from '../../../../molecules/Modal'
import { Button as CustomButton, Input } from '../../../../styled'
import { getHeaders, getList } from './employeeList'
import AddNewEmployee from './forms/AddNewEmployee.form'
import PageHeader from './PageHeader'
import PageContent from './page_content'



export default function Main() {

    const [isExportModalOpen, setIsExportModalOpen] = useState(false)
    const [isAddModalOpen, setIsAddModalOpen] = useState(false)



    const handleOnHeaderBtnSecondaryClick =()=>{
        setIsExportModalOpen(isExportModalOpen ? false : true)
    }
    const handleOnHeaderBtnPrimaryClick =()=>{
        setIsAddModalOpen(isAddModalOpen ? false : true)
    }

    const handleOnExport = ()=>{

        let salesHistory = getList()
        let objKeys:(string|number)[][] = []

        salesHistory.forEach((history)=>{
            const arr = Object.values(history)
            objKeys.push(arr)
        })

        const aoa = [
            getHeaders(),
            ...objKeys
        ]

        spreadsheet.aoaToSpreadSheet(aoa, "Employee list")
        setIsExportModalOpen(false)
        
        
    }

    const handleOnNewEmployeeAdded = ()=>{

        pubsub.trigger("employee-list:changed")

        setIsAddModalOpen(false)
        
        toast("Employee added successfully",{
            position:"top-center",
            theme: "dark",
            hideProgressBar: true,
            type: "success"
        })
        
    }
    
    const handleOnCreateEmployeeFail = (e:any)=>{
        
        setIsAddModalOpen(false)
        
        toast("Failed to add new employee",{
            position:"top-center",
            theme: "dark",
            hideProgressBar: true,
            type: "error"
        })
        throw e
    }

    return (
        <Stack
            direction="column"
            spacing={2}
        >
            <PageHeader onBtnPrimaryClick={handleOnHeaderBtnPrimaryClick} onBtnSecondaryClick={handleOnHeaderBtnSecondaryClick} />
            <PageContent/>

            {/* Export modal */}
            <Modal
                title="Export employee history"
                subtitle="Select time range to export data"
                visible={isExportModalOpen}
                setVisibility={setIsExportModalOpen}
            >
                <Box
                >
                    <Stack 
                        direction="row"
                        sx={{width: "100%", marginBottom: "1rem"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">Start Date:</Typography>
                            <Input type="date" />
                        </Stack>
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="grey.500">End Date:</Typography>
                            <Input type="date" />
                        </Stack>
                    </Stack>

                    <Box
                        sx={{marginTop: "1.5rem", display: "flex", justifyContent: "flex-end"}}
                    >
                       <CustomButton 
                            startIcon={<BsFileEarmarkArrowDown />} 
                            variant="contained" 
                            color="secondary" 
                            disableElevation={true}
                            onClick={handleOnExport}
                        >
                            <Typography color="primary" sx={{fontSize:"13px"}}>Download</Typography>
                        </CustomButton>
                    </Box>

                </Box>
            </Modal>

            {/* Add Modal */}
            <Modal
                title="Add to new employee"
                subtitle="Please complete the form to add new employee"
                visible={isAddModalOpen}
                setVisibility={setIsAddModalOpen}
            >
                <AddNewEmployee 
                    onDone={handleOnNewEmployeeAdded}
                    onFail={handleOnCreateEmployeeFail}
                />
            </Modal>

        </Stack>
    )

}
